export default __webpack_public_path__ + "static/media/new-stars.eb3fe915.svg";